// extracted by mini-css-extract-plugin
module.exports = {"root":"IconButton_root__0fs_d","outlined":"IconButton_outlined__bG_sc"};